<template>
  <div class="mobile-navigation-top show-on-mobile-flex">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-list-item-avatar v-bind="attrs" v-on="on">
          <v-icon>mdi-menu</v-icon>
        </v-list-item-avatar>
      </template>
      <v-list dense>
        <v-list-item
          link
          :to="item.link"
          v-for="(item, index) in itemsFiltered"
          :key="index"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "MobileNavigationTop",
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    ...mapGetters("user", ["currentUser"]),
    itemsFiltered() {
      return this.items.filter((el) => el.show);
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">
[role="menu"] {
  position: fixed;
  bottom: 0;
  background: #ffffff;
  right: 0 !important;
  border-radius: 16px 0 0 16px !important;
  top: 0 !important;
  left: auto !important;
  padding: 24px 16px !important;
  z-index: 8000 !important;
  box-shadow: -4px 0 24px rgba(0, 0, 0, 0.1);
  width: 280px !important;
  transition: transform 0.3s ease-in-out;

  .v-list {
    padding: 8px 0 !important;
    
    .v-list-item {
      border-radius: 8px;
      margin: 4px 0;
      transition: background-color 0.2s ease;
      
      &:hover {
        background-color: rgba(0, 0, 0, 0.04);
      }
      
      .v-list-item__icon {
        margin-right: 12px;
        color: #666;
      }
      
      .v-list-item__title {
        font-size: 0.95rem;
        font-weight: 500;
        color: #333;
      }
    }
  }
}
</style>